// public/js/modules/toastNotifications.js


const Toast = (function() {
  let container = null;
  const DEFAULT_DURATION = 4000; 
  
  
  function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  
  
  const ICONS = {
    success: 'fa-check-circle',
    error: 'fa-times-circle',
    warning: 'fa-exclamation-triangle',
    info: 'fa-info-circle'
  };
  
  
  const DEFAULT_TITLES = {
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info'
  };

  
  function initContainer() {
    if (container) return;
    
    container = document.getElementById('toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'toast-container';
      document.body.appendChild(container);
    }
  }

  
  function show(type, title, message = '', options = {}) {
    initContainer();
    
    const {
      duration = DEFAULT_DURATION,
      persist = false
    } = options;
    
    
    const toastId = 'toast-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    
    
    const toast = document.createElement('div');
    toast.id = toastId;
    toast.className = `toast-notification toast-${type}`;
    
    
    const iconClass = ICONS[type] || ICONS.info;
    const displayTitle = title || DEFAULT_TITLES[type];
    
    toast.innerHTML = `
      <div class="toast-icon">
        <i class="fas ${iconClass}"></i>
      </div>
      <div class="toast-content">
        <div class="toast-title">${escapeHtml(displayTitle)}</div>
        ${message ? `<div class="toast-message" style="opacity: 0; transform: translateX(100vw);">${escapeHtml(message)}</div>` : ''}
      </div>
      <button class="toast-close" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
      ${!persist ? `<div class="toast-progress" style="animation-duration: ${duration}ms;"></div>` : ''}
    `;
    
    
    const closeBtn = toast.querySelector('.toast-close');
    closeBtn.addEventListener('click', () => dismiss(toastId));
    
    
    container.appendChild(toast);
    
    
    let dismissTimeout;
    if (!persist && duration > 0) {
      dismissTimeout = setTimeout(() => dismiss(toastId), duration);
    }
    
    
    checkAndApplyAutoScroll(toast, toastId, duration, persist, dismissTimeout);
    
    console.log(`[Toast] ${type}: ${displayTitle}${message ? ' - ' + message : ''}`);
    
    return toastId;
  }
  
  
  function checkAndApplyAutoScroll(toast, toastId, baseDuration, persist, existingTimeout) {
    const messageEl = toast.querySelector('.toast-message');
    const contentEl = toast.querySelector('.toast-content');
    if (!messageEl || !contentEl) return;
    
    requestAnimationFrame(() => {
      setTimeout(() => {
        
        const containerWidth = contentEl.clientWidth;
        const textWidth = messageEl.scrollWidth;
        
        
        messageEl.style.opacity = '1';
        messageEl.style.transform = 'none';
        
        
        const scrollDistance = containerWidth + textWidth;
        const scrollSpeed = 60; 
        
        
        const pauseDuration = 1000;
        
        
        const calculatedDuration = (scrollDistance / scrollSpeed) * 1000;
        const scrollDuration = Math.max(calculatedDuration, 3000);
        
        
        const totalDuration = pauseDuration + scrollDuration;
        
        
        const pauseOffset = pauseDuration / totalDuration;
        
        const animation = messageEl.animate([
          { transform: `translateX(${containerWidth}px)`, offset: 0 },
          { transform: `translateX(${containerWidth}px)`, offset: pauseOffset }, 
          { transform: `translateX(-${textWidth}px)`, offset: 1 }
        ], {
          duration: totalDuration,
          iterations: 1,
          easing: 'linear',
          fill: 'forwards'
        });

        
        toast.addEventListener('mouseenter', () => {
          animation.pause();
          const progressEl = toast.querySelector('.toast-progress');
          if (progressEl) {
            progressEl.style.animationPlayState = 'paused';
          }
        });
        
        toast.addEventListener('mouseleave', () => {
          animation.play();
          const progressEl = toast.querySelector('.toast-progress');
          if (progressEl) {
            progressEl.style.animationPlayState = 'running';
          }
        });

        toast.addEventListener('touchstart', () => {
          animation.pause();
          const progressEl = toast.querySelector('.toast-progress');
          if (progressEl) {
            progressEl.style.animationPlayState = 'paused';
          }
        }, { passive: true });

        toast.addEventListener('touchend', () => {
          animation.play();
          const progressEl = toast.querySelector('.toast-progress');
          if (progressEl) {
            progressEl.style.animationPlayState = 'running';
          }
        }, { passive: true });
        
        
        animation.onfinish = () => {
          if (!persist) {
            dismiss(toastId);
          }
        };
        
        
        if (!persist && baseDuration > 0) {
          clearTimeout(existingTimeout);
          
          
          const progressEl = toast.querySelector('.toast-progress');
          if (progressEl) {
            progressEl.style.animation = 'none';
            void progressEl.offsetWidth; 
            progressEl.style.animation = `toast-progress-shrink ${totalDuration}ms linear forwards`;
          }
        }
      }, 50); 
    });
  }

  
  function dismiss(toastId) {
    const toast = document.getElementById(toastId);
    if (!toast) return;
    
    
    toast.classList.add('toast-exit');
    
    
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  }

  
  function dismissAll() {
    if (!container) return;
    
    const toasts = container.querySelectorAll('.toast-notification');
    toasts.forEach((toast, index) => {
      setTimeout(() => dismiss(toast.id), index * 50);
    });
  }

  
  function success(title, message, options) {
    return show('success', title, message, options);
  }

  
  function error(title, message, options) {
    return show('error', title, message, options);
  }

  
  function warning(title, message, options) {
    return show('warning', title, message, options);
  }

  
  function info(title, message, options) {
    return show('info', title, message, options);
  }

  
  function custom(type, title, message, options) {
    return show(type, title, message, options);
  }

  
  return {
    show,
    dismiss,
    dismissAll,
    success,
    error,
    warning,
    info,
    custom,
    
    playing: (songTitle, artist = '') => {
      const msg = artist ? `${songTitle} by ${artist}` : songTitle;
      return success('Now Playing', msg, { duration: 3000 });
    },
    uploadSuccess: (fileName) => success('Upload Complete', fileName),
    uploadFailed: (reason = 'Please try again') => error('Upload Failed', reason),
    saved: (item = 'Changes saved') => success('Saved', item, { duration: 2500 }),
    deleted: (item = 'Item deleted') => info('Deleted', item),
    lotteryWon: (prize, winner) => success('Congratulations!', `${winner} won ${prize}!`, { duration: 5000 }),
    songAdded: (songTitle) => success('Added to Queue', songTitle, { duration: 2500 }),
    songRemoved: (songTitle) => info('Removed from Queue', songTitle),
    profileUpdated: () => success('Profile Updated', 'Your changes have been saved'),
    connectionError: () => error('Connection Error', 'Please check your internet connection'),
    rateLimited: (time = 'a moment') => warning('Slow Down', `Please wait ${time} before trying again`),
  };
})();


if (typeof module !== 'undefined' && module.exports) {
  module.exports = Toast;
}


window.Toast = Toast;


export { Toast };

console.log('[Toast] Notification system loaded');
